
import type { PropOptions } from 'vue';
import Vue from 'vue';
import CloseIcon from '@/assets/svg/close.vue.svg';

interface IData {
  videoOpened: boolean;
  video: string;
}

export default Vue.extend({
  name: 'WarRoomLandingVideo',
  components: {
    CloseIcon,
  },
  props: {
    videoId: {
      type: String,
      required: true,
      default: null,
    } as PropOptions<string>,
  },
  data(): IData {
    return {
      videoOpened: false,
      video: `//www.youtube.com/embed/${this.videoId}?showinfo=0&autoplay=1&enablejsapi=1`,
    };
  },
  methods: {
    handleOpen(): void {
      this.videoOpened = true;
    },
    handleClose(): void {
      this.videoOpened = false;
    },
  },
});
